import type { ComponentType } from "react";
import CategorySectionsPage from "./CategorySectionsPage";
import IntroCategoryPage from "./IntroCategoryPage";
import SuitesCategoryPage from "./SuitesCategoryPage";
import CulinaryCategoryPage from "./CulinaryCategoryPage";
import ThingsToDoCategoryPage from "./ThingsToDoCategoryPage";
import EnhanceCategoryPage from "./EnhanceCategoryPage";
import GroupsEventsCategoryPage from "./GroupsEventsCategoryPage";
import type { CategoryRow, SectionRow } from "@/lib/categories.functions";

export type CategoryComponentProps = {
  category: CategoryRow;
  sections: SectionRow[];
  appendCta?: boolean;
  experienceSlug?: string | null;
  isActive?: boolean;
  initialThingsTab?: "onsite" | "nearby";
};

const BY_ID: Record<string, ComponentType<CategoryComponentProps>> = {
  intro: IntroCategoryPage,
  suites: SuitesCategoryPage,
  culinary: CulinaryCategoryPage,
  "things-to-do": ThingsToDoCategoryPage,
  onsite: ThingsToDoCategoryPage,
  nearby: ThingsToDoCategoryPage,
  enhance: EnhanceCategoryPage,
  "groups-events": GroupsEventsCategoryPage,
};

const BY_SLUG: Record<string, ComponentType<CategoryComponentProps>> = {
  intro: IntroCategoryPage,
  suites: SuitesCategoryPage,
  culinary: CulinaryCategoryPage,
  "things-to-do": ThingsToDoCategoryPage,
  onsite: ThingsToDoCategoryPage,
  nearby: ThingsToDoCategoryPage,
  enhance: EnhanceCategoryPage,
  groups: GroupsEventsCategoryPage,
};


export function getCategoryComponent(
  id: string | null,
  slug?: string | null,
): ComponentType<CategoryComponentProps> {
  if (id && BY_ID[id]) return BY_ID[id];
  if (slug && BY_SLUG[slug]) return BY_SLUG[slug];
  return CategorySectionsPage;
}

export { CategorySectionsPage };
